export const types = {
  SHOW_HINT: 'SHOW_HINT',
  SHOW_ANSWER: 'SHOW_ANSWER',
  HIDE_ANSWER: 'HIDE_ANSWER',
  SET_WORD: 'SET_WORD',
  SPEECH: 'SPEECH',
  SET_QUESTIONS: 'SET_QUESTIONS',
};
